import { render } from "./Locations.vue?vue&type=template&id=31d3817e"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"
script.render = render

export default script